import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { AgentsPage } from './_dashboard.devices.agents'

export const Route = createFileRoute('/_dashboard/devices/agents/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: AgentsItemPage,
})

function AgentsItemPage() {
  const { item } = Route.useParams()
  return <AgentsPage selectedId={item} />
}
